import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  portfolioQueryKeys,
  portfolioSnowflakeCredentialsUrl,
} from '@/lib/portfolio/api';
import type { CreateSnowflakeCredentialResponse } from '@/lib/portfolio/snowflake-types';

export function useCreateSnowflakeCredential(portfolioId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiPost<CreateSnowflakeCredentialResponse>(
        portfolioSnowflakeCredentialsUrl(portfolioId),
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.snowflakeCredentials(portfolioId),
      });
    },
  });
}
